import {
    RaikoButtonPrimary,
    RaikoCustomSelect,
    RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoMoneyInputOutlined,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    showServerErrorMessage,
    showSuccessMessage,
    showWarningMessage,
    RaikoToggleOutlined, raikoCustomSelectItemGenerator, RaikoFlexAlignEnd, showErrorMessage, RaikoGridTwoColumn
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useState} from "react";
import React from "react";
import {transactionTypeStatus} from "./CashTransactions";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {useAuthState} from "../../context/AuthContext";
import {CostAndRevenueService} from "../../serverService/costAndRevenueService/CostAndRevenueService";

export default function AddNewCashTransaction(
    {
        tagList,
        categoryList,
        addNewItemToTable
    }) {
    const {fundID} = useAuthState()
    const [statusFilter, setStatusFilter] = useState(transactionTypeStatus.ALL.id);
    const [title, setTitle] = useState("");
    const [amount, setAmount] = useState("");
    const [date, setDate] = useState("");
    const [tagSelectedID, setTagSelectedID] = useState(-1);
    const [selectedCategoryId, setSelectedCategoryId] = useState(-1);
    const [enabled, setEnabled] = useState(true);
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);

    const service = new CostAndRevenueService();


    function checkAllInputs() {
        let message = ""
        let state = false

        if (title.length === 0)
            message = "لطفا عنوان را به درستی وارد نمایید."
        else if (amount === "0" || amount.length === 0)
            message = "لطفا مبلغ تراکنش را مشخص نمایید!"
        else if (date.length === 0)
            message = "لطفا تاریخ تراکنش را به درستی مشخص نمایید!"
        else
            state = true
        if (message && message.length > 0)
            showWarningMessage(message)
        return state
    }

    function handleAddNewCashTransaction() {
        if (checkAllInputs()) {
            setLoading(true)
            service.addNewCashTransaction(
                fundID,
                title,
                amount,
                date,
                statusFilter,
                enabled,
                description,
                tagSelectedID,
                selectedCategoryId
            ).then(response => {
                showSuccessMessage("تراکنش جدید با موفقیت افزوده شد.")
                addNewItemToTable(response)
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                setLoading(false)
            })
        }
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoGridTwoColumn>
                <RaikoSimpleInputOutlined
                    labelText={"عنوان"}
                    value={title}
                    setValue={setTitle}
                />
                <RaikoCustomSelect
                    labelText={"نوع تراکنش"}
                    setValue={setStatusFilter}
                    items={[
                        raikoCustomSelectItemGenerator(transactionTypeStatus.COST.id, transactionTypeStatus.COST.name),
                        raikoCustomSelectItemGenerator(transactionTypeStatus.REVENUE.id, transactionTypeStatus.REVENUE.name),
                    ]}
                    value={statusFilter}
                />
                <RaikoMoneyInputOutlined
                    labelText={"مبلغ (ریال)"}
                    value={amount}
                    setValue={setAmount}/>
                <RaikoDatePicker
                    label={"تاریخ"}
                    date={date}
                    setDate={setDate}/>
                <RaikoCustomSelect
                    labelText={"تگ"}
                    value={tagSelectedID}
                    setValue={setTagSelectedID}
                    items={
                        [raikoCustomSelectItemGenerator(-1, "هیچکدام"),
                            ...tagList
                        ]
                    }
                />
                <RaikoCustomSelect
                    labelText={"دسته بندی"}
                    setValue={setSelectedCategoryId}
                    items={
                        [raikoCustomSelectItemGenerator(-1, "هیچکدام"),
                            ...categoryList
                        ]
                    }
                    value={selectedCategoryId}
                />
                <RaikoToggleOutlined
                    labelText={"فعال / غیر فعال"}
                    setChecked={setEnabled}
                    checked={enabled}
                />

            </RaikoGridTwoColumn>
            <RaikoSimpleMultiLineInputOutlined
                labelText={"توضیحات"}
                value={description}
                setValue={setDescription}
            />

            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary
                    label={"افزودن"}
                    loading={loading}
                    onClick={handleAddNewCashTransaction}
                />
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}